<template>
  <div class="p-fluid w-5">
    <span class="zapi-search-pill">            
      <InputText 
        ref="searchInput"
        :modelValue="modelValue" 
        @update:modelValue="$emit('update:modelValue', $event)"
        @keydown.esc="clearSearch"
        placeholder="Buscar producto (F2 para limpiar)..."
        class="w-full"
        data-testid="pos-buscar"
      />
      <i v-if="modelValue" class="pi pi-times cursor-pointer clear-icon" @click="clearSearch" title="Limpiar búsqueda" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'ZapiSearchBar',
  props: {
    modelValue: { type: [String, Object], default: null }
  },
  emits: ['update:modelValue'],
  mounted() {
    window.addEventListener('keydown', this.handleGlobalKeydown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleGlobalKeydown);
  },
  methods: {
    /**
     * Limpia el valor de la barra de búsqueda emitiendo un texto vacío al padre.
     * Luego, vuelve a enfocar el input para que el cajero pueda seguir escribiendo.
     */
    clearSearch() {
      this.$emit('update:modelValue', '');
      this.focusInput();
    },
    
    /**
     * Busca la referencia nativa del campo de texto en el DOM
     * y le aplica el foco (focus) para activar el cursor inmediatamente.
     */
    focusInput() {
      if (this.$refs.searchInput) {
        const inputEl = this.$refs.searchInput.$el || this.$refs.searchInput;
        if (inputEl && inputEl.focus) {
          inputEl.focus();
        }
      }
    },
    
    /**
     * Escucha los eventos del teclado a nivel global (window).
     * Si el usuario presiona 'F2', previene acciones por defecto
     * y dispara la limpieza y el auto-enfoque de la barra de búsqueda.
     * 
     * @param {KeyboardEvent} e - Evento disparado por el teclado.
     */
    handleGlobalKeydown(e) {
      if (e.key === 'F2') {
        e.preventDefault();
        this.clearSearch();
      }
    }
  }
}
</script>

<style scoped>
.zapi-search-pill {
  position: relative;
  display: block; /* Para que tome el 100% en p-fluid */
  width: 100%;
}
.zapi-search-pill :deep(.p-inputtext) {
  border-radius: 999px;
  padding-right: 2.5rem; /* Espacio para que el texto no pise la X */
  width: 100%;
}
.clear-icon {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  transition: color 0.2s;
  z-index: 2; /* Asegurar que esté por encima del input */
}
.clear-icon:hover {
  color: #ef4444;
}
</style>